import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import 'primeicons/primeicons.css';

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useUserStore } from '@/stores/user';

import App from './App.vue'
import router from './router'

import "./styles.css";

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
    ripple: true,
}
);
app.use(ToastService);

const userStore = useUserStore();
userStore.checkAuth;

app.mount('#app')
